// confirm-snackbar.component.ts
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-snackbar',
  templateUrl: './confirm-snackbar.component.html',
  styleUrls: ['./confirm-snackbar.component.scss'],
})
export class ConfirmSnackbarComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmSnackbarComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onOkClick() {
    this.dialogRef.close();
    if (this.data.onOk) {
      this.data.onOk();
    }
  }
}
